module.exports = __webpack_public_path__ + "static/media/freight-people-home-bg-blurred.be2c685c.jpg";